import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';

const WinWinChemical = () => {
  const theme = useTheme();

  return (
    <Box marginBottom={4}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="primary"
        align="center"
      >
        Estrategia ganar-ganar
      </Typography>
      <Typography variant="h4" fontWeight={700} align="center" color="primary" gutterBottom>
        Prospectos calificados y propósito editorial
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              p: 2.5,
              height: '100%',
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
            }}
          >
            <Typography variant="h6" fontWeight={700} color="primary" gutterBottom>
              Para Chemical
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Base de datos y <strong>leads</strong> interesados en emprender: personas que ya consumieron el mensaje en
              TNO Business y en el Digest, con intención declarada al hacer clic en WhatsApp.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              p: 2.5,
              height: '100%',
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
            }}
          >
            <Typography variant="h6" fontWeight={700} color="primary" gutterBottom>
              Para TNO Network
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Contenido con impacto social y económico: TNO se posiciona como <strong>motor de desarrollo</strong> para
              emprendedores, con marcas que aportan historias reales y utilidad.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default WinWinChemical;
